import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { IAuthCommon, IAuthTable } from '../auth.interfaces';
import { ApproverAuthActions, ApproverAuthActionTypes } from './approver-auth.actions';

export const authAdapter: EntityAdapter<IAuthCommon> = createEntityAdapter<
  IAuthCommon
>();

export function authInitState(): IAuthTable {
  return authAdapter.getInitialState({});
}

export function approverAuthReducer(state = authInitState(), action: ApproverAuthActions) {
  switch (action.type) {
    case ApproverAuthActionTypes.APPROVER_LOGIN_SUCCESS:
    case ApproverAuthActionTypes.APPROVER_REFRESH_TOKEN_SUCCESS:

      return {
        ...state,
        ...action.payload,
      };

    case ApproverAuthActionTypes.APPROVER_LOGOUT:
      return authInitState();

    default:
      return state;
  }
}
